
import { mapState, mapGetters } from 'vuex'
import finance from '~/mixins/common/pages/finance'
import bankAccount from '~/mixins/common/bank-account'
export default {
    mixins: [finance, bankAccount],
    data() {
        return {
            step: 0,
            steppers: 1,
            existLoading: false,
            resultData: {},
            amount: '',
            isWithdrawalSuccessful: false,
        }
    },
    computed: {
        ...mapState({
            player: (state) => state.player.player,
            withdrawalExistingData: (state) =>
                state.themes.withdraw.withdrawalExistingData,
            operationSetting: (state) => state.settings.operationSetting,
        }),
        ...mapGetters({
            exchangeRates: 'themes/settings/exchangeRate',
            bankAccount: 'themes/player-bank/bankAccount',
        }),
        primaryBankAccount() {
            const foundBankAccount =
                this.bankAccount?.player_bank_accounts?.find(
                    (account) => account.is_primary
                )
            return foundBankAccount || {}
        },
        exchangeRate() {
            const foundRate = this.exchangeRates.find(
                (rate) =>
                    rate.from_currency === this.player.currency &&
                    rate.to_currency === this.primaryBankAccount.currency
            )
            return foundRate ? foundRate.rate : 0
        },
        isExchange() {
            if (!this.primaryBankAccount?.currency) return false
            if (this.player.currency === this.primaryBankAccount?.currency)
                return false
            return true
        },
    },
    watch: {
        withdrawalExistingData(data) {
            this.checkExistingInitialize(data)
        },
    },
    mounted() {
        this.checkExistingInitialize(this.withdrawalExistingData)
        this.$root.withdrawExistChange = (item) => {
            if (!item?.is_exist) {
                if (this.steppers !== 3) {
                    this.steppers = 1
                }
                this.resultData = {}
                this.$emit('enableDisabledPaymentMethod', { is_exist: false })
            }
        }
        // subscribe socket actions for deposit
        this.subscribeAction = this.$store.subscribeAction(
            (mutation, state) => {
                if (mutation.type === 'sockets/successfulWithdrawal') {
                    this.steppers = 3
                    this.isWithdrawalSuccessful = true
                }
                if (mutation.type === 'sockets/revokeWithdrawal') {
                    this.steppers = 3
                    this.isWithdrawalSuccessful = false
                }
            }
        )
    },
    beforeDestroy() {
        this.doCancelAxiosRequest()
        // unsubscribe the store action
        if (this.subscribeAction) {
            this.subscribeAction()
        }
    },
    destroyed() {
        this.$root.withdrawExistChange = null
    },
    methods: {
        checkExistingInitialize(data) {
            // If no data available and object is empty
            if (!data && Object.keys(data).length === 0) return
            if (!this.player?.has_bank_account) return
            if (data?.is_exist) {
                this.resultData = data
                this.steppers = 2
            }
        },
        doWithdraw(result) {
            if (result) {
                this.resultData = result
                this.steppers = 2
                this.$emit('enableDisabledPaymentMethod', {
                    is_exist: true,
                    channel: 'bank',
                })
            }
        },
        clearForm() {
            this.$refs?.refWithdraw?.reset()
        },
        cancelPending(result) {
            if (result) {
                this.resultData = {}
                this.steppers = 1
                this.$emit('enableDisabledPaymentMethod', {
                    is_exist: false,
                    channel: 'bank',
                })
                // To clear the existing withdrawal data
                this.$store.commit(
                    'themes/withdraw/setWithdrawalExistingData',
                    {}
                )
            }
        },
    },
}
